export default __webpack_public_path__ + "static/measure-tape-reference-438d3d7a03af0d7cfd8ecde71996190e.jpg";